module.exports = __webpack_public_path__ + "static/media/file_example_WAV_1MG.f2101cf8.wav";